var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsFloodSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 53,
    viewBox: "0 0 47 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.953 6.76C32.6215 3.42841 28.1901 1.59766 23.4806 1.59766C18.7646 1.59766 14.3398 3.42841 11.0082 6.76C7.67658 10.0916 5.83936 14.5229 5.83936 19.2324C5.83936 28.7614 14.8508 36.6926 19.6962 40.9492C20.369 41.5444 20.9447 42.0554 21.4105 42.4824C21.9927 43.0258 22.7367 43.2975 23.4806 43.2975C24.2246 43.2975 24.9685 43.0258 25.5443 42.4824C26.01 42.0554 26.5922 41.5444 27.265 40.9492C32.1039 36.6926 41.1154 28.7614 41.1154 19.2324C41.1154 14.5229 39.2846 10.0916 35.953 6.76Z",
    fill: "#38BCDB",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.847 11.9707L27.407 12.0293L27.5484 13.0913L27.9885 13.0327C28.5236 12.9617 29.0764 13.1087 29.5052 13.4367C29.9342 13.7649 30.2206 14.2598 30.2921 14.7948L30.3507 15.2349L31.4127 15.0934L31.3541 14.6534C31.2455 13.8385 30.8089 13.085 30.156 12.5856C29.5034 12.0865 28.662 11.8622 27.847 11.9707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6036 14.9358L33.6653 14.7929L33.6478 14.6649C33.4464 13.153 32.6692 11.8104 31.4577 10.8837C30.2462 9.95702 28.7473 9.55786 27.236 9.75945L27.1072 9.7763L27.2471 10.8384L27.3767 10.8216C28.6047 10.6581 29.8231 10.9823 30.8069 11.7348C31.7907 12.4874 32.4229 13.578 32.5862 14.8071L32.6036 14.9358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6409 8.57305C29.2466 8.53804 30.8333 9.0562 32.1092 10.0322C33.3848 11.0079 34.3002 12.4037 34.6869 13.9628L34.8679 14.6922L35.9082 14.4344L35.727 13.7048C35.2825 11.9105 34.2285 10.3036 32.7603 9.18052C31.2922 8.05778 29.4652 7.46142 27.6174 7.50153L26.8655 7.51808L26.8889 8.5896L27.6409 8.57305Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4708 13.9722C18.7444 13.9722 14.8989 17.8178 14.8989 22.5441C14.8989 27.2705 18.7445 31.1159 23.4708 31.1159C28.1972 31.1159 32.0427 27.2703 32.0427 22.5441C32.0427 17.8176 28.1971 13.9722 23.4708 13.9722ZM21.8635 28.9731H20.792V27.9017H21.8635V28.9731ZM24.0065 28.9731H22.9351V27.9017H24.0065V28.9731ZM26.1496 28.9731H25.0782V27.9017H26.1496V28.9731ZM23.6512 26.2943H23.2896C21.9101 26.2943 20.7914 25.1756 20.7914 23.7962C20.7914 23.3278 20.9232 22.8693 21.1712 22.4724L23.4702 18.794L25.7691 22.4724C26.0171 22.8693 26.1489 23.3281 26.1489 23.7962C26.1495 25.1758 25.0308 26.2943 23.6512 26.2943ZM27.5184 28.8831L26.9243 27.9916C28.7882 26.7493 29.9004 24.6704 29.9004 22.431C29.9004 18.948 27.0674 16.115 23.5844 16.115H23.3584C19.8754 16.115 17.0424 18.9479 17.0424 22.431C17.0424 24.6705 18.1546 26.749 20.0185 27.9916L19.4229 28.8831C17.2607 27.4419 15.9701 25.0295 15.9701 22.431C15.9701 18.3571 19.2842 15.0436 23.3576 15.0436H23.5836C27.6575 15.0436 30.971 18.3576 30.971 22.431C30.9712 25.0288 29.6807 27.4413 27.5184 28.8831H27.5184Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4553",
    x: 0.339355,
    y: 0.0976562,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4553",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsFloodSensor);
export default __webpack_public_path__ + "static/media/eventsFloodSensor.9e46db20b71fe5e8da00cc01dea1992f.svg";
export { ForwardRef as ReactComponent };